<template>
  <aside class="market-sidebar">
    <PagesMarketComponentsSidebarComponentsSidebarMarketInfo
      :market="market"
    />
    <div>
      <PagesMarketComponentsSidebarComponentsShortInfo
        :market="market"
      />

      <LazyPagesMarketComponentsSidebarComponentsGamesList
        v-if="market.supported_games?.length"
        :games="(market.supported_games || []) as MarketFullInfoSupportedGame[]"
      />
    </div>

    <LazyPagesMarketComponentsSidebarComponentsCountries
      v-if="market.top_countries?.length"
      :countries="(market.top_countries || []) as MarketFullInfoTopCountry[]"
    />

    <LazyPagesMarketComponentsSidebarComponentsApps
      v-if="market.apps?.length"
      :apps="(market.apps || []) as MarketFullInfoApp[]"
    />

    <PagesMarketComponentsSidebarComponentsPayments
      :payments="(market.payment_methods || []) as MarketFullInfoPaymentMethod[]"
      :payouts="(market.payout_methods || []) as MarketFullInfoPaymentMethod[]"
    />
  </aside>
</template>

<script lang="ts" setup>
import type {
  MarketFullInfo,
  MarketFullInfoApp,
  MarketFullInfoPaymentMethod,
  MarketFullInfoSupportedGame,
  MarketFullInfoTopCountry,
} from '~/graphql/generated/schema-types';

defineProps<{
  market: MarketFullInfo
}>();
</script>

<style lang="scss" scoped>
@use 'sass:color';

.market-sidebar {
  width: 280px;
  display: flex;
  flex-direction: column;
  gap: 36px;

  &__title, &:deep(.market-sidebar__title) {
    color: var(--surfaces-on-surface);
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }

  &__title-small, &:deep(.market-sidebar__title-small) {
    color: var(--surfaces-on-surface);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 137.5% */
    margin-bottom: 16px;
  }

  .sidebar-market-info {
    display: none;
  }

  @media screen and (max-width: 850px) {
    width: 100%;
    gap: 8px;

    .sidebar-market-info {
      display: flex;
    }

    &__title, &:deep(.market-sidebar__title) {
      font-size: 20px;
      line-height: 28px
    }
    &__title-small, &:deep(.market-sidebar__title-small) {
      font-size: 16px;
      line-height: 22px;
    }
  }
}
</style>
